// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InferencesView-view-4a57{width:100dvw;height:var(--screen-height)}`, "",{"version":3,"sources":["webpack://./src/page/Fullscreen/Inferences/InferencesView.module.scss"],"names":[],"mappings":"AAAA,0BACE,YAAA,CACA,2BAAA","sourcesContent":[".view {\n  width: 100dvw;\n  height: var(--screen-height);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `InferencesView-view-4a57`
};
module.exports = ___CSS_LOADER_EXPORT___;
